import { Result } from "appworks/model/gameplay/records/results/result";

export class SlingoLadderResult extends Result {
    public resultType: string = "SlingoLadderResult";

    public increase: number = 0;
    public total: number = 0;

    public otherPrizes: any;
}